import { render, staticRenderFns } from "./PageVmLoyalty.vue?vue&type=template&id=e5852b8a&"
import script from "./PageVmLoyalty.vue?vue&type=script&lang=js&"
export * from "./PageVmLoyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports